import { buildEndPoint } from '@mairistem/tools';
import { TYPES_PRODUIT } from '@/constants';
import type { ProduitType } from '@/types';
import baseUrl from './base';

export const postProduit = () => `${baseUrl}/produits`;

export const searchProduits = (
  { query, perPage } = {
    query: '',
    perPage: 10,
  },
) =>
  buildEndPoint(`${baseUrl}/produits/search`, {
    q: query,
    perPage: perPage || 10,
  });
export const putProduit = (id: number) => `${baseUrl}/produits/${id}`;
export const deleteProduit = (id: number) => `${baseUrl}/produits/${id}`;

export const getProduits = (
  { page, comptant } = { page: 1 } as { page?: number; comptant?: boolean },
) => `${baseUrl}/produits?perPage=30
  &page=${page}
  &groupOn=libelle,article,codeProduitLocal,identifiantLogicielFacturier
  &sort=libelle:asc${comptant ? `&type=${encodeURIComponent(TYPES_PRODUIT.AU_COMPTANT)}` : ''}`;

export const getProduitsParametrage = (
  { page, comptant } = { page: 1 } as { page?: number; comptant?: boolean },
) => `${baseUrl}/produits?perPage=30
  &page=${page}
  &groupOn=libelle,article,codeProduitLocal,identifiantLogicielFacturier
  &priorityBy=payableCESU,payableChequeVacance
  &sort=libelle${comptant ? `&type=${encodeURIComponent(TYPES_PRODUIT.AU_COMPTANT)}` : ''}`;

export const getProduitsParametrageDetail = (
  { produit, page, comptant } = { page: 1 } as {
    produit: ProduitType;
    page?: number;
    comptant?: boolean;
  },
) => `${baseUrl}/produits?perPage=30
  &page=${page}
  &libelle=${produit.libelle}
  &article=${produit.article}
  &codeProduitLocal=${produit.codeProduitLocal}
  ${produit.logicielFacturier?.identifiant ? `&identifiantLogicielFacturier=${produit.logicielFacturier.identifiant}` : ''}
  &groupOn=libelle,article,codeProduitLocal,fonction,ventilation,compteAnalytique,compteAnalytique2,siret,codeCollectivite,codeBudget
  &sort=fonction:asc,ventilation:asc,compteAnalytique:asc,compteAnalytique2:asc,siret:asc${comptant ? `&type=${encodeURIComponent(TYPES_PRODUIT.AU_COMPTANT)}` : ''}`;
